// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.ChampionsTournamentCollectBonusChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.ChampionsPurchasedByDays"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.ChampionsTournamentPlayerPerformance"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.ChampionsTournamentGroupSizeAverage"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="game_events.ChampionsTournamentGroupSizes"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;